import React from 'react';
import styled from '@emotion/styled';
import TypeChanger from '~ComponentsImproved/TSR/TypeChanger';
import { useCart } from '~Components/CartProvider';

export const ItemsContainer = styled.div`
  flex: 1;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 32px;
`;

export interface Props {
  children: any;
  changeItemCourseType: string | null;
  closeCourseChanger: () => void;
}

const ItemsWrapper = ({ children, changeItemCourseType, closeCourseChanger }: Props) => {
  const cart = useCart();

  return (
    <ItemsContainer data-test="cart-items">
      {children}
      {changeItemCourseType && (
        <TypeChanger
          onChange={(type) => {
            cart.setItemCourseType(changeItemCourseType, type);
            closeCourseChanger();
          }}
          onClose={() => {
            closeCourseChanger();
          }}
        />
      )}
    </ItemsContainer>
  );
};

export default React.memo(ItemsWrapper);
